import ProviderListv2WithState from "./ProviderListv2WithState";

const ProviderListv2 = ({
  caseInfo,
  setReFetchStaticBar,
  providerInfo,
  count,
  loading,
}) => {
  return (
    <ProviderListv2WithState
      caseInfo={caseInfo}
      setReFetchStaticBar={setReFetchStaticBar}
      providerInfo={providerInfo}
      count={count}
      loading={loading}
    />
  );
};

export default ProviderListv2;
